import { forwardRef } from 'react';
import { tv } from 'tailwind-variants';
import { Slot } from '@radix-ui/react-slot';
import { cn } from '../lib/cn';

const button = tv({
  base:
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-medium ' +
    'transition-colors duration-120 ease-out-smooth focus-ring ' +
    'disabled:opacity-50 disabled:cursor-not-allowed',
  variants: {
    variant: {
      primary:
        'bg-[hsl(var(--primary))] text-[hsl(var(--primary-fg))] ' +
        'hover:bg-[hsl(var(--primary)/0.88)] shadow-elev-1',
      secondary:
        'bg-[hsl(var(--bg-raised))] text-[hsl(var(--fg))] ' +
        'border border-[hsl(var(--border))] hover:border-[hsl(var(--border-strong))]',
      ghost:
        'bg-transparent text-[hsl(var(--fg))] ' +
        'hover:bg-[hsl(var(--bg-raised))]',
      danger:
        'bg-[hsl(var(--danger))] text-[hsl(var(--danger-fg))] ' +
        'hover:bg-[hsl(var(--danger)/0.88)]',
      accent:
        'bg-[hsl(var(--accent))] text-[hsl(var(--accent-fg))] ' +
        'hover:bg-[hsl(var(--accent)/0.88)] shadow-elev-1',
      link:
        'bg-transparent text-[hsl(var(--accent))] hover:underline px-0 h-auto',
    },
    size: {
      sm: 'h-8 px-3 text-xs',
      md: 'h-10 px-4 text-sm',
      lg: 'h-12 px-5 text-base',
      icon: 'h-9 w-9 p-0',
    },
  },
  defaultVariants: {
    variant: 'primary',
    size: 'md',
  },
});

export const Button = forwardRef(function Button(
  { className, variant, size, asChild = false, ...props },
  ref
) {
  const Comp = asChild ? Slot : 'button';
  return (
    <Comp
      ref={ref}
      className={cn(button({ variant, size }), className)}
      {...props}
    />
  );
});
